import React, { useState } from 'react'
import UserList from './UserList'
import UserPoint from './UserPoint'

const UserManagement = () => {
  
  const [pages, setPages] = useState(0);

  return (
    // <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
    //   <div className='flex justify-between items-center'>
    //     <ul className='flex gap-5'>
    //       <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto ${pages === 0 && 'border-[1px] border-yellow-500 rounded-md'}`} onClick={(e)=>setPages(0)}>고객 목록</li>
    //       {/* <li className={`hover:underline cursor-pointer py-2 px-5 overflow-x-auto ${pages === 0 && 'border-[1px] border-yellow-500 rounded-md'}`} onClick={(e)=>setPages(1)}>포인트 내역 (공사중)</li> */}
    //     </ul>
    //     {/* <div>
    //       <button className='px-5 py-3 text-yellow-400'>새로고침</button>
    //     </div> */}
    //   </div>
    //   <div className=''>
    //     {
    //       (pages === 0 && <UserList/>) || (pages === 1 && <UserPoint/>)
    //     }
    //   </div>
    // </div>
    <div className=''>
      <UserList/>
    </div>
  )
}

export default UserManagement